export default __webpack_public_path__ + "static/media/Ballroll_00243.83dbfba7.png";